import states from "../variables/statesAndCities";

new Vue({
    el: "#highlights-consultants",
    data: {
        model: {},
        loading: true,
        form: {
            name: "",
            state: ""
        },
        states: states,
        modal: {
            show: false,
            view: "profile",
            consultant: {},
            message: "",
            error: "",
            sending: false
        }
    },
    created: function() {
        this.getItems();

        const currentUrl = window.location.href;
        var consultant_id = currentUrl.split("-id-")[1] || false;
        if (consultant_id) this.getConsultantById(consultant_id);
    },
    methods: {
        async getItems(page = 1) {
            var self = this;

            const nameSearch = self.form.name != "" ? `&name=${self.form.name}` : "";
            const stateSearch = self.form.state != "" ? `&state=${self.form.state}` : "";

            self.loading = true;

            try {
                const response = await axios.get(
                    `/api/consultants?page=${page}&per_page=12${nameSearch}${stateSearch}`
                );

                self.model = response.data;
            } finally {
                self.loading = false;
            }
        },
        async getItemsByPage(page) {
            await this.getItems(page);
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#highlights-consultants").offset().top - 100
                },
                0
            );
        },
        openProfile(id) {
            var self = this;
            const consultant = self.model.data.filter(item => id == item.id)[0] || self.modal.consultant;

            self.modal.consultant = consultant;
            self.modal.view = "profile";
            self.modal.error = "";
            self.modal.show = true;

            window.history.pushState(
                [],
                "Dell Expert Network",
                `/consultores-elite-certificados/${self.slugfy(consultant.name)}-id-${consultant.id}`
            );
        },
        openMessageForm() {
            this.modal.message = "";
            this.modal.error = "";
            this.modal.view = "message";
        },
        async sendMessage() {
            var self = this;

            if (self.modal.message.trim() == "") {
                self.modal.error = "Escreva uma mensagem antes de enviar.";
                return;
            }

            self.modal.error = "";
            self.modal.sending = true;

            try {
                await axios.post(`/api/consultants/${self.modal.consultant.id}/message`, {
                    message: self.modal.message
                });
                self.modal.view = "confirm";
            } catch (error) {
                const data = error.response && error.response.data;
                self.modal.error =
                    (data && data.errors && data.errors.message && data.errors.message[0]) ||
                    (data && data.message) ||
                    "Não foi possível enviar a mensagem agora. Tente novamente mais tarde.";
            } finally {
                self.modal.sending = false;
            }
        },
        closeModal() {
            this.modal.show = false;
            window.history.pushState([], "Dell Expert Network", "/consultores-elite-certificados");
        },
        slugfy(text) {
            return (text || "")
                .toString()
                .toLowerCase()
                .normalize("NFD")
                .trim()
                .replace(/\s+/g, "-")
                .replace(/[^\w\-]+/g, "")
                .replace(/\-\-+/g, "-");
        },
        async getConsultantById(id) {
            var self = this;
            const response = await axios.get(`/api/consultants/${id}`);
            self.modal.consultant = response.data;
            self.modal.view = "profile";
            self.modal.show = true;
        }
    }
});
